module.exports = __webpack_public_path__ + "media/apps/shopper_app_512-8ce69c00.png";